/* eslint-disable no-unused-vars */
// ライフエール独自対応
import Vue from "vue";
import Router from 'vue-router'
import store from '@/store'
import _ from 'lodash'
import VueGtag from "vue-gtag";
import routes from './routes'
// import UserRepository from '@/repositories/repository-user'
// import UserRepositoryMock from '@/repositories/mock/repository-user'
// import CONST_DATA from '@/mixins/const/constData'
import { createSetCookie, parseCookie } from "@/utils/cookie";
// ライフエール独自対応
// import axios from 'axios';

// const UserRepo = process.env.NODE_ENV === CONST_DATA.ENV.LOCAL ? UserRepositoryMock : UserRepository

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from) {
    if (to.path === from.path) {
      return
    }
    return { x: 0, y: 0 }
  },
  routes
})

// lifeとstayで別になるはず
// レベル1認証必須画面
const authTargetList = [
  "CrlyMemberStatus", // 加入状況
  "CrlyEntry", // 入会確認画面
  "CrlyFavorite" // お気に入り
];

// レベル2認証必須画面
const twoFactorAuthTargetList = [
  "MyPage", // マイページ
  "MypageMembershipPass", // 会員証
  "MypageOrders", // ご利用履歴（申し込み履歴）
  "MypageBenepo", // ベネポの確認
  "MypageSetting", // 個人設定
  "plan_details",
  "DpPlanDetail",
  "BS_PLN_02_001_プラン詳細：宿泊",
  "BS_APP_02_001_NEW",
  "BS_APP_02_001 申込(何を・どこに)",
];

router.beforeEach(async (to, from, next) => {
  router['referrer'] = from;

  const cookie = parseCookie(document.cookie);
  if (authTargetList.includes(to.name)) {
    // backUriに指定するドメイン選択
    let backUriDomain = location.origin;
    if (to.name === "CrlyMemberStatus" || to.name === "CrlyFavorite" || to.name === "CrlyEntry") {
      backUriDomain = process.env.VUE_APP_TOP_DOMAIN;
    }
    // 会員登録時は auth_type=1 を付けて sb-login を呼び出す
    if (to.path === "/entry") {
      window.open(
        process.env.VUE_APP_API_URL +
          "/v1/stay/sb-login?auth_type=1&back_uri=" +
          backUriDomain +
          "/entryConfirm",
        "_self"
      );
      return false;
    } else {
      // レベル1認証のログイン状態の確認
      if (!cookie.LYLv1AtLimitAuthenticatedCookie) {
        document.cookie = createSetCookie("back_uri", to.fullPath);
        // レベル1認証画面に遷移
        window.open(
          process.env.VUE_APP_API_URL +
          "/v1/stay/sb-login?back_uri=" +
          backUriDomain + to.fullPath,
          "_self"
        );
        return false;
      } else {
        // ユーザー情報有効期限の確認
        if (!cookie.LYUserLimitCookie) {
          window.open(
            process.env.VUE_APP_API_URL +
            "/v1/stay/sb-login?back_uri=" +
            backUriDomain + to.fullPath,
            "_self"
          );
          return false;
        } else {
          // ログイン済フラグを設定
          store.commit('auth/setLoggedIn', true);
        }
      }
    }
  }

  if (twoFactorAuthTargetList.includes(to.name)) {
    // backUriに指定するドメイン選択
    let backUriDomain = location.origin;
    if (
      to.name === "MyPage" ||
      to.name === "MypageMembershipPass" ||
      to.name === "MypageOrders" ||
      to.name === "MypageBenepo" ||
      to.name === "MypageSetting"
    ) {
      backUriDomain = process.env.VUE_APP_MYPAGE_DOMAIN;
    }
    // レベル2認証のログイン状態の確認
    if (!cookie.LYLv2AtLimitAuthenticatedCookie) {
      document.cookie = createSetCookie("back_uri", to.fullPath);
      // レベル2認証画面に遷移
      window.open(
        process.env.VUE_APP_API_URL +
          "/v1/stay/sb-login?acr_value=2&back_uri=" +
          backUriDomain + to.fullPath,
        "_self"
      );
      return false;
    } else {
      // ユーザー情報有効期限の確認
      if (!cookie.LYUserLimitCookie) {
        window.open(
          process.env.VUE_APP_API_URL +
            "/v1/stay/sb-login?acr_value=2&back_uri=" +
            backUriDomain + to.fullPath,
          "_self"
        );
        return false;
      } else {
        // ログイン済フラグを設定
        store.commit('auth/setLoggedIn', true);
      }
    }
  }
  if ( to.name !== 'sessionTimeOut' && to.name !== 'callback' ) {
    sessionStorage.setItem('currentHref', process.env.VUE_APP_BASE_URL + to.fullPath)
  }

  //required login check 
  if (
    ['/pages/no-valid-plan-menu', '/pages/not-found', '/pages/internal-error'].includes(to.path)
  ) {
    next(true)
    return
  }
/*
  const userInfo = store.getters['auth/get'].user
  if (userInfo) {
    store.commit('auth/setLoggedIn', true)
    next(true)
  } else {
    if (to.path === '/authorization/cb') {
      next(true)
      return
    }
    //  CHECK AUTHEN ON FIRST TIME LOAD PAGE
    try {
      let contractInfoAPI = await UserRepo.contractInfo();
      
      const contracts = contractInfoAPI.data.contractInfo
      // last selected contract in previous logged in
      const lastSelectedContract = store.getters['persist/get']._lastSelectedContract
      let selectedContract = null
      if (contracts.length > 1 && lastSelectedContract) {
        // select last selected contract
        selectedContract = _.get(
          contracts.filter((c) => c.customerNo === lastSelectedContract.customerNo),
          '[0]'
        )
      } else if (contracts.length >= 1) {
        // auto select if have only 1 contract
        selectedContract = contracts[0]
      }
      if (!selectedContract) {
        // set not logged in
        store.commit('auth/setLoggedIn', false)
        next(true)
      } else {
        // get user info
        let userInfoAPI = await UserRepo.postUser();
        // SSO対応による未ログイン判定処理(BS契約のない契約情報のパターンが存在する)
        if (!userInfoAPI.data) {
          store.commit('auth/setLoggedIn', false);
        } else {
          //ユーザー情報が取得できた場合のみログイン判定とする
          const userInfo = {
            ...userInfoAPI.data,
            contract: selectedContract,
            isCompleteFirstLogin: undefined
          }
          // save user info to state
          store.commit('auth/set', { user: userInfo });
          store.commit('auth/setLoggedIn', true);
        }
        next(true)
      }
    } catch (error) {
      store.commit('auth/setLoggedIn', false)
      next(true)
    }

    // CRM独自対応
    if (
      process.env.NODE_ENV !== CONST_DATA.ENV.LOCAL &&
      to.meta.requiredLogin &&
      !store.getters['auth/get'].user
    ) {
      if(to.name === 'plan_details' || to.name === 'DpPlanDetail') {
        try {
          const ssocheckResponse = await axios.get(process.env.VUE_APP_AUTHORIZATION + '/v1/ssocheck/BS/', {withCredentials: true});
          return window.location = (`${process.env.VUE_APP_API_URL}/v1/stay/login`)
        } catch (error) {
          if(error.response.status === 401){
            sessionStorage.setItem("currentHref", to.fullPath);
            next('/authorization/cb?ssocheck=select');
          }else{
            return window.location = (`${process.env.VUE_APP_API_URL}/v1/stay/login`)
          }
        }
      }
      else{
        store.commit('auth/setLoggedIn', true)
        window.location.href = process.env.VUE_APP_TOP_DOMAIN
        return
      }
    }
  }*/
  next();
})

// ライフエール独自対応
// router.beforeEach((to, from, next) => {
//   if (to.path === '/authorization/cb' || to.path === '/v1/stay/login' || to.path === '/v1/stay/logout'){
//       next();
//   } else {
// 	  // サーバーのチェックAPIを呼び出す
// 	  axios.get(process.env.VUE_APP_AUTHORIZATION + '/v1/ssocheck/BS/', {withCredentials: true})
// 	  .then(response => {
// 	    // SSOチェックの応答に基づいて何か処理をする場合
// 	    switch (response.status) {
// 	      case 200:
// 	        // 成功時の処理
// 	        next()
// 	        break;
// 	      default:
// 	        next()
// 	    }
// 	  })
// 	  .catch(error => {
// 	    switch (error.response.status) {
// 	      case 401:
// 	        next('/authorization/cb');
// 	        break;
// 	      case 403:
// 	        window.location.href = process.env.VUE_APP_AUTHORIZATION + "/v1/stay/login";
//             break;
// 	      default:
// 	        next()
// 	    }
// 	  })
//   }
// });

router.afterEach(() => {
  // Remove initial loading
})

export default router

Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GOOGLE_CODE }
  },
  router
);
